import axiosAgent from './axiosAgent';
import ApiConfig from '../config/ApiConfig';

export const sendRequest = async (id) => {
    const response = await axiosAgent.post(
        `${ApiConfig.request.send}/${id}`,
        {}
    );
    console.log('response of create request=', response);
};

export const findAllRequestOfInstructor = async () => {
    const response = await axiosAgent.get(
        `${ApiConfig.request.findAllRequest}`
    );
    console.log('response of getAll Instructor', response.data);
    return response.data.data;
};

export const acceptRequest = async (requestId) => {
    const response = await axiosAgent.post(
        `${ApiConfig.request.acceptRequest}/${requestId}`,
        {}
    );
    console.log('RESponse of accept Request', response);
};

export const declineRequest = async (requestId) => {
    const response = await axiosAgent.post(
        `${ApiConfig.request.declineRequest}/${requestId}`,
        {}
    );
};

export const excelRequestAccept = async (formData) => {
    const response = await axiosAgent.post(
        ApiConfig.request.excelRequestAccept,
        formData
    );
    return response;
};
